/**
 * Data layer for `starter-plan-single-client-basic-tracking-capped-clicks-convs`. Thin typed fetch wrappers over /api/v1/starter-plan-single-client-basic-tracking-capped-clicks-convs.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface StarterPlanSingleClientBasicTrackingCappedClicksConvsRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListStarterPlanSingleClientBasicTrackingCappedClicksConvsResponse {
	count: number;
	items: StarterPlanSingleClientBasicTrackingCappedClicksConvsRow[];
}

export interface CreateStarterPlanSingleClientBasicTrackingCappedClicksConvsBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/starter-plan-single-client-basic-tracking-capped-clicks-convs";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListStarterPlanSingleClientBasicTrackingCappedClicksConvsResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListStarterPlanSingleClientBasicTrackingCappedClicksConvsResponse>(res);
}

export async function create(body: CreateStarterPlanSingleClientBasicTrackingCappedClicksConvsBody): Promise<StarterPlanSingleClientBasicTrackingCappedClicksConvsRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<StarterPlanSingleClientBasicTrackingCappedClicksConvsRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const starterPlanSingleClientBasicTrackingCappedClicksConvsQueryKeys = {
	all: ["starter-plan-single-client-basic-tracking-capped-clicks-convs"] as const,
	list: () => [...starterPlanSingleClientBasicTrackingCappedClicksConvsQueryKeys.all] as const,
	detail: (id: string) => [...starterPlanSingleClientBasicTrackingCappedClicksConvsQueryKeys.all, id] as const,
};
